import { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { startEditQuickRequest } from "api/services/quickRequest";
import errorToast from "helpers/errorToast";
import { useRequestFormMode } from "@RequestFormV2/context/requestFormMode";

type Params = {
  isEditQuickRequest: boolean;
  enabled?: boolean;
};

export function useQuickRequestEditBootstrap({ isEditQuickRequest, enabled = false }: Params) {
  const mode = useRequestFormMode();
  const { shipmentId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const draftId = searchParams.get("draft_id");
  const attemptedRef = useRef(false);
  const [isBootstrapping, setIsBootstrapping] = useState(false);
  const [bootstrapFailed, setBootstrapFailed] = useState(false);

  useEffect(() => {
    if (!enabled || !isEditQuickRequest || mode !== "quick" || !shipmentId || draftId || attemptedRef.current) {
      return;
    }

    let cancelled = false;
    attemptedRef.current = true;
    setIsBootstrapping(true);
    setBootstrapFailed(false);

    startEditQuickRequest(shipmentId)
      .then((res) => {
        if (cancelled) return;
        searchParams.set("draft_id", res.data.draft_reference);
        setSearchParams(searchParams);
      })
      .catch((err) => {
        if (cancelled) return;
        setBootstrapFailed(true);
        errorToast(err);
      })
      .finally(() => {
        if (!cancelled) setIsBootstrapping(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, isEditQuickRequest, mode, shipmentId, draftId, searchParams, setSearchParams]);

  return { isBootstrapping, bootstrapFailed };
}
